import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

const useRenameVendor = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, newName }: { id: number; newName: string }) => {
      return (await glynt).vendor.renameVendor(id, newName);
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendors'],
      });
    },
  });
};

export default useRenameVendor;
